export var HandlerRole;

(function (HandlerRole) {
  HandlerRole["SOURCE"] = "SOURCE";
  HandlerRole["TARGET"] = "TARGET";
})(HandlerRole || (HandlerRole = {}));


//////////////////
// WEBPACK FOOTER
// ./~/dnd-core/dist/esm/interfaces.js
// module id = 240
// module chunks = 4